export const redirectPage = ({ url }) => {
  window.location.assign(url);
};
